import "core-js/modules/es6.array.find";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paste-from-office/pastefromoffice
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import GoogleDocsNormalizer from "./normalizers/googledocsnormalizer";
import MSWordNormalizer from "./normalizers/mswordnormalizer";
import Clipboard from '@ckeditor/ckeditor5-clipboard/src/clipboard';
/**
 * The Paste from Office plugin.
 *
 * This plugin handles content pasted from Office apps and transforms it (if necessary)
 * to a valid structure which can then be understood by the editor features.
 *
 * Transformation is made by a set of predefined {@link module:paste-from-office/normalizer~Normalizer normalizers}.
 * This plugin includes following normalizers:
 *   * {@link module:paste-from-office/normalizers/mswordnormalizer~MSWordNormalizer Microsoft Word normalizer}
 *   * {@link module:paste-from-office/normalizers/googledocsnormalizer~GoogleDocsNormalizer Google Docs normalizer}
 *
 * For more information about this feature check the {@glink api/paste-from-office package page}.
 *
 * @extends module:core/plugin~Plugin
 */

var PasteFromOffice =
/*#__PURE__*/
function (_Plugin) {
  _inherits(PasteFromOffice, _Plugin);

  function PasteFromOffice() {
    _classCallCheck(this, PasteFromOffice);

    return _possibleConstructorReturn(this, _getPrototypeOf(PasteFromOffice).apply(this, arguments));
  }

  _createClass(PasteFromOffice, [{
    key: "init",

    /**
     * @inheritDoc
     */
    value: function init() {
      var editor = this.editor;
      var normalizers = [];
      normalizers.push(new MSWordNormalizer());
      normalizers.push(new GoogleDocsNormalizer());
      editor.plugins.get('Clipboard').on('inputTransformation', function (evt, data) {
        if (data.isTransformedWithPasteFromOffice) {
          return;
        }

        var htmlString = data.dataTransfer.getData('text/html');
        var activeNormalizer = normalizers.find(function (normalizer) {
          return normalizer.isActive(htmlString);
        });

        if (activeNormalizer) {
          activeNormalizer.execute(data);
          data.isTransformedWithPasteFromOffice = true;
        }
      }, {
        priority: 'high'
      });
    }
  }], [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'PasteFromOffice';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [Clipboard];
    }
  }]);

  return PasteFromOffice;
}(Plugin);

export { PasteFromOffice as default };